import './style.scss'

import { TRouteItems } from 'types/routes'


export const RouteTitle = ({ routeItems }: {
    routeItems: TRouteItems
}) => (
    <span className="route-title">{routeItems[routeItems.length - 1]?.title}</span>
)
